import React from 'react'
import { createThemeIcon } from '../../helper/createThemeIcon'
import SafeImage from '../../components/BasicComponent/SafeImage'
import ResultNoViolationDefault from '../images/result_no_violation.png'
import ResultHasViolationDefault from '../images/result_has_violation.png'
import ResultNoViolationBIDV from '../images/BIDV/result_no_violation.png'
import ResultHasViolationBIDV from '../images/BIDV/result_has_violation.png'
import EmptyVehicleDefault from '../images/quanlydangki_khongcoxe.png'
import EmptyVehicleBIDV from '../images/BIDV/registration_empty_vehicle.png'
import trafficFineBenefits12Default from '../images/traffic_fine_benifits_12.png'
import trafficFineBenefits12V2Default from '../images/traffic_fine_benifits_12_v2.png'
import trafficFineBenefits12BIDV from '../images/BIDV/traffic_fine_benifits_12.png'
import trafficFineBenefits13Default from '../images/traffic_fine_benifits_13.png'
import trafficFineBenefits13V2Default from '../images/traffic_fine_benifits_13_v2.png'
import trafficFineBenefits13BIDV from '../images/BIDV/traffic_fine_benifits_13.png'
import trafficFineBenefits14Default from '../images/traffic_fine_benifits_14.png'
import trafficFineBenefits14V2Default from '../images/traffic_fine_benifits_14_v2.png'
import trafficFineBenefits14BIDV from '../images/BIDV/traffic_fine_benifits_14.png'
import { ReactComponent as PlusCircleWhiteDefault } from './plus_circle_white.svg'
import PlusCircleBIDV from './BIDV/plus_circle.png'
import { ReactComponent as VehicleMotoDefault } from './icon_vehicle_moto.svg'
import { ReactComponent as VehicleCarDefault } from './icon_vehicle_car.svg'
import { ReactComponent as VehicleElectricDefault } from './icon_vehicle_electric.svg'
import { ReactComponent as VehicleMotoBIDV } from './BIDV/icon_vehicle_moto.svg'
import { ReactComponent as VehicleCarBIDV } from './BIDV/icon_vehicle_car.svg'
import { ReactComponent as VehicleElectricBIDV } from './BIDV/icon_vehicle_electric.svg'

import { ReactComponent as SupportQuestionDefault } from './card_link_support_question.svg'
import { ReactComponent as SupportPunishDefault } from './card_link_support_punish.svg'
import { ReactComponent as SupportServiceDefault } from './card_link_support_service.svg'
import { ReactComponent as SupportQuestionBIDV } from './BIDV/card_link_support_question.svg'
import { ReactComponent as SupportPunishBIDV } from './BIDV/card_link_support_punish.svg'
import { ReactComponent as SupportServiceBIDV } from './BIDV/card_link_support_service.svg'

import { ReactComponent as ArrowRightDefault } from './arrow_right.svg'
import { ReactComponent as ArrowRightBIDV } from './BIDV/arrow_right.svg'
import { ReactComponent as ArrowRightFullBIDV } from './BIDV/arrow_right_full.svg'
import { ReactComponent as ArrowDownDefault } from './arrow_down.svg'
import { ReactComponent as ArrowDownBIDV } from './BIDV/arrow_down.svg'

import { ReactComponent as CloseDefault } from './close.svg'
import { ReactComponent as CloseBIDV } from './BIDV/close.svg'
import { ReactComponent as CheckCircleGreenDefault } from './check_circle_green.svg'
import { ReactComponent as CheckCircleGreenBIDV } from './BIDV/check_circle_green.svg'

export { ReactComponent as IconBottomBarManage } from './bottom_bar_manage.svg'
export { ReactComponent as IconBottomBarSearch } from './bottom_bar_search.svg'
export { ReactComponent as IconGreenCheck } from './green_check.svg'
export { ReactComponent as IconCloseCircle } from './close_circle.svg'
export { ReactComponent as IconPhoneCircleBrand } from './phone_circle_brand.svg'
export { ReactComponent as IconPhoneCallStroke } from './phone_call_stroke.svg'
export { ReactComponent as IconClock } from './clock.svg'
export { ReactComponent as IconCheckCircleWhite } from './check_circle_white.svg'
export { ReactComponent as IconGoiDichVuGiaTien } from './goidichvu_giatien.svg'
export { ReactComponent as IconGoiDichVuSoLuongXe } from './goidichvu_soluongxe.svg'
export { ReactComponent as IconGoiDichVuSoLuongXeMay } from './goidichvu_soluongxemay.svg'
export { ReactComponent as IconArrowLeft } from './arrow_left.svg'
export { ReactComponent as IconInfoCircle } from './info_circle.svg'
export { ReactComponent as AutomatedTrafficFineNotificationAuthenticationHideInfo } from './authentication_hide_info.svg'
export { ReactComponent as AutomatedTrafficFineNotificationAuthenticationShowInfo } from './authentication_show_info.svg'
export { ReactComponent as IconNopPhatNguoi } from './nopPhatNguoi_circle_brand.svg'
export { ReactComponent as IconHtArrowLeft } from './icon_ht_arrow-left.svg'

export const IconClose = createThemeIcon({
  default: CloseDefault,
  BIDV: CloseBIDV
})

export const IconCheckCircleGreen = createThemeIcon({
  default: CheckCircleGreenDefault,
  BIDV: CheckCircleGreenBIDV
})

export const IconArrowRightFull = createThemeIcon({
  default: ArrowRightDefault,
  BIDV: ArrowRightFullBIDV
})

export const IconArrowRight = createThemeIcon({
  default: ArrowRightDefault,
  BIDV: ArrowRightBIDV
})

export const IconArrowDown = createThemeIcon({
  default: ArrowDownDefault,
  BIDV: ArrowDownBIDV
})

export const IconCardLinkSupportQuestion = createThemeIcon({
  default: SupportQuestionDefault,
  BIDV: SupportQuestionBIDV
})

export const IconCardLinkSupportPunish = createThemeIcon({
  default: SupportPunishDefault,
  BIDV: SupportPunishBIDV
})

export const IconCardLinkSupportService = createThemeIcon({
  default: SupportServiceDefault,
  BIDV: SupportServiceBIDV
})

export const IconVehicleMoto = createThemeIcon({
  default: VehicleMotoDefault,
  BIDV: VehicleMotoBIDV
})

export const IconVehicleCar = createThemeIcon({
  default: VehicleCarDefault,
  BIDV: VehicleCarBIDV
})

export const IconVehicleElectric = createThemeIcon({
  default: VehicleElectricDefault,
  BIDV: VehicleElectricBIDV
})

const createImageIcon = (src) => (props) => <SafeImage src={src} {...props} />

export const IconResultNoViolation = createThemeIcon({
  default: createImageIcon(ResultNoViolationDefault),
  BIDV: createImageIcon(ResultNoViolationBIDV)
})

export const IconResultHasViolation = createThemeIcon({
  default: createImageIcon(ResultHasViolationDefault),
  BIDV: createImageIcon(ResultHasViolationBIDV)
})

export const IconRegistrationEmptyVehicle = createThemeIcon({
  default: createImageIcon(EmptyVehicleDefault),
  BIDV: createImageIcon(EmptyVehicleBIDV)
})

export const IconPlusCircleWhite = createThemeIcon({
  default: PlusCircleWhiteDefault,
  BIDV: createImageIcon(PlusCircleBIDV)
})

export const IconTrafficFineBenefit12 = createThemeIcon({
  default: createImageIcon(trafficFineBenefits12Default),
  BIDV: createImageIcon(trafficFineBenefits12BIDV)
})

export const IconTrafficFineBenefit12V2 = createThemeIcon({
  default: createImageIcon(trafficFineBenefits12V2Default),
  BIDV: createImageIcon(trafficFineBenefits12BIDV)
})

export const IconTrafficFineBenefit13 = createThemeIcon({
  default: createImageIcon(trafficFineBenefits13Default),
  BIDV: createImageIcon(trafficFineBenefits13BIDV)
})

export const IconTrafficFineBenefit13V2 = createThemeIcon({
  default: createImageIcon(trafficFineBenefits13V2Default),
  BIDV: createImageIcon(trafficFineBenefits13BIDV)
})

export const IconTrafficFineBenefit14 = createThemeIcon({
  default: createImageIcon(trafficFineBenefits14Default),
  BIDV: createImageIcon(trafficFineBenefits14BIDV)
})

export const IconTrafficFineBenefit14V2 = createThemeIcon({
  default: createImageIcon(trafficFineBenefits14V2Default),
  BIDV: createImageIcon(trafficFineBenefits14BIDV)
})


